
























import { Component, Vue } from 'vue-property-decorator';

interface Social {
  Url: string;
  Icon: string;
}

@Component
export default class Footer extends Vue {
  readonly socials: Social[] = [
    {
      Url: 'https://github.com/Ealenn/',
      Icon: 'github'
    },
    {
      Url: 'https://twitter.com/Ealen_',
      Icon: 'twitter'
    },
    {
      Url: 'https://www.linkedin.com/in/rudymarchandise',
      Icon: 'linkedin'
    }
  ];
  readonly date: Date = new Date();
}
